if(!window.$isMobile) {
    document.querySelectorAll('.PhotoSliderAS__slider').forEach((container) => {
        container.style.display = 'flex';
        container.querySelectorAll('img').forEach((img, i) => {
            if(i < 5) {
                img.removeAttribute('loading');
            }
        });
        Array.from(container.children).forEach(el => {
            el.style.flexShrink = '0'
        })
    });
}
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.PhotoSliderAS__slider').forEach((container) => {
        const images = container.querySelectorAll('img');
        const count = container.children.length;
        const isCenter = count < 3;

        const slider = tns({
            container,
            mouseDrag: true,
            loop: false,
            autoWidth: !window.$isMobile,
            nav: false,
            lazyload: true,
            controls: true,
            center: false,
        }).then((slider) => {
            console.log(slider);
            imgAllAwait([...images]).then(() => {
                slider.refresh();
                console.log('loaded all images');
            })
        });
    })

})

function imgAllAwait(list) {
    return Promise.all(list.map(imgAwait));
}
function imgAwait(img) {
    if(img) {
        return new Promise((resolve, reject) => {
            if(img.complete) resolve();
            else {
                img.addEventListener('load', resolve);
                img.addEventListener('error', reject);
            }
        })
    }
}
